const mutations = {
  getOnBoardingScreens: (state, onboarding_screen) => {
    state.onboarding_screen = onboarding_screen;
  },
  getOnBoardingScreen: (state, onboarding_screen_id) => {
    state.onboarding_screen_id = onboarding_screen_id;
  },
  getSlideScreen: (state, slide_screen) => {
    state.slide_screen = slide_screen;
  },
  postOnBoardingScreen: (state, new_onboarding_screen) => {
    state.onboarding_screen.push(new_onboarding_screen);
  },
  updateOnBoardingScreens: (state, new_status) => {
    state.onboarding_screen = state.onboarding_screen.map((onboarding_screen) => {
      if (onboarding_screen.id === new_status.onboarding_screen_id) {
        return Object.assign({}, onboarding_screen, new_status.status);
      }
      return onboarding_screen;
    });
  },
  putOnBoardingScreen: (state, payload) => {
    state.onboarding_screen = state.onboarding_screen.map((onboarding_screen) => {
      if (onboarding_screen.onboarding_screen_id === payload.id) {
        return Object.assign({}, onboarding_screen, payload.formData);
      }
      return onboarding_screen;
    });
  },
  delOnBoardingScreen(state, id) {
    const index = state.onboarding_screen.findIndex(onboarding_screen => onboarding_screen.onboarding_screen_id == id);
    state.onboarding_screen.splice(index, 1);
  },
};

export default mutations;
